const endpoints = {
    "self_info": {
        "url": "/user/me",
        "method": "get"
    },
    "login": {
        "url": "/user/token",
        "method": "post"
    },
    "check_username_availability": {
        "url": "/user/check-username",
        "method": "get"
    },
    "check_email_availability": {
        "url": "/user/check-email",
        "method": "get"
    },
    "signup": {
        "url": "/user/signup",
        "method": "post"
    },
    "search_users": {
        "url": "/user/search",
        "method": "get"
    },
    "get_user_detail_by_id": {
        "url": "/user/detail/{id}",
        "method": "get"
    },
    "deactivate_user": {
        "url": "/user/deactivate/{id}",
        "method": "put"
    },
    "toggle_activate_user": {
        "url": "/user/toggle-activate/{id}",
        "method": "put"
    },
    "make_user_a_staff": {
        "url": "/user/make-staff/{id}",
        "method": "put"
    },
    "make_user_a_superuser": {
        "url": "/user/make-superuser/{id}",
        "method": "put"
    },
    "delete_user": {
        "url": "/user/delete/{id}",
        "method": "delete"
    },
    "resend_activate_email": {
        "url": "/user/resend-activate-email/{id}",
        "method": "post"
    },
    "update_user_info": {
        "url": "/user/update-info",
        "method": "put"
    },
    "admin_update_user_info": {
        "url": "/user/update-info/{id}",
        "method": "put"
    },
    "change_password": {
        "url": "/user/change-password",
        "method": "put"
    },
    "request_reset_password": {
        "url": "/user/request-reset-password",
        "method": "post"
    },
    "reset_password": {
        "url": "/user/reset-password/{token}",
        "method": "post"
    },
    "notes_list": {
        "url": "/note/notes",
        "method": "get"
    },
    "get_note": {
        "url": "/note/get/{note_name}",
        "method": "get"
    },
    "update_note": {
        "url": "/note/update/{note_name}",
        "method": "put"
    },
    "create_note": {
        "url": "/note/create",
        "method": "post"
    },
    "upload_note": {
        "url": "/note/upload",
        "method": "post"
    },
    "delete_note": {
        "url": "/note/delete/{note_name}",
        "method": "delete"
    },
    "read_note": {
        "url": "/note/read/{note_name}",
        "method": "get"
    },
    "file_upload": {
        "url": "/photo/upload",
        "method": "post"
    },
    "search_photos": {
        "url": "/photo/search",
        "method": "get"
    },
    "update_photo": {
        "url": "/photo/update/{id}",
        "method": "put"
    },
    "get_photo_exif": {
        "url": "/photo/get-photo-exif",
        "method": "post"
    },
    "delete_photo": {
        "url": "/photo/delete/{id}",
        "method": "delete"
    },
    "create_album": {
        "url": "/album/create",
        "method": "post"
    },
    "search_albums": {
        "url": "/album/search",
        "method": "get"
    },
    "get_album": {
        "url": "/album/by-id/{id}",
        "method": "get"
    },
    "update_album": {
        "url": "/album/update",
        "method": "put"
    },
    "delete_album": {
        "url": "/album/delete/{id}",
        "method": "put"
    },
    "post_contact": {
        "url": "/contact/post-this-is-not-necessary-but-i-got-too-many-spam-mail",
        "method": "post"
    },
    "all_contacts": {
        "url": "/contact/all",
        "method": "get"
    },
    "contact_content": {
        "url": "/contact/content/{id}",
        "method": "get"
    },
    "delete_contact": {
        "url": "/contact/delete/{id}",
        "method": "delete"
    },
    "toggle_read": {
        "url": "/contact/toggle-read/{id}",
        "method": "put"
    },
    "set_app_version": {
        "url": "/system/set-app-version",
        "method": "post"
    },
    "system_info": {
        "url": "/system/info",
        "method": "get"
    },
    "upload_cv": {
        "url": "/system/upload-cv",
        "method": "post"
    }
}
export default endpoints;